module.exports = __webpack_public_path__ + "img/status-report-badge-3.ed4d95af.svg";